import { useSelector } from "react-redux";

export const useCourseMapData = () =>
  useSelector((state) => state.CourseMap.courseMapDetails.courseMapData);
export const useEditableCourseItem = () =>
  useSelector((state) => state.CourseMap.editableCourseItem);
export const useVisibleCourseElements = () =>
  useSelector((state) => state.CourseMap.visibleCourseElements);
export const useCourseGPSMappingData = () =>
  useSelector((state) => state.CourseMap.courseMapDetails.courseGPSMappingData);
// export const useEditableHazardItem = () =>
//   useSelector((state) => state.CourseMap.editableHazardItem);
export const useSelectedCourseZoneType = () =>
  useSelector((state) => state.CourseMap.selectedCourseZoneType);
export const useCourseGPSNameList = () =>
  useSelector((state) => state.CourseMap.courseGPSNameList);
export const useCourseShapePropertiesType = () =>
  useSelector((state) => state.CourseMap.shapePropertiesType);
export const useCoursePolygonPropertiesType = () =>
  useSelector((state) => state.CourseMap.polygonPropertiesType);
export const useCoursePolygonPropertiesDesc = () =>
  useSelector((state) => state.CourseMap.polygonPropertiesDesc);
export const useCourseBridgePropertiesDesc = () =>
  useSelector((state) => state.CourseMap.bridgePropertiesDesc);
export const useCourseShapePropertiesSize = () =>
  useSelector((state) => state.CourseMap.shapePropertiesSize);
export const useCourseShapeBackgroundType = () =>
  useSelector((state) => state.CourseMap.shapeBackgroundPropertiesType);
export const useCourseShapeBackgroundDesc = () =>
  useSelector((state) => state.CourseMap.shapeBackgroundPropertiesDesc);
export const useCourseShapePropertiesDesc = () =>
  useSelector((state) => state.CourseMap.shapePropertiesDesc);
export const useIsDrawingStatus = () =>
  useSelector((state) => state.CourseMap.isDrawingStatus);
export const useVisibleFacilityElements = () =>
  useSelector((state) => state.CourseMap.visibleFacilityElements);
export const useGoogleAddress = () =>
  useSelector((state) => state.CourseMap.google_location_data);
export const useGlobalSaveStatus = () =>
  useSelector((state) => state.CourseMap.global_save_status);
export const useTransformedCourseData = () =>
  useSelector((state) => state.CourseMap.transformedCourseData);
export const useTransformedHoleData = () =>
  useSelector((state) => state.CourseMap.transformedHoleData);
export const useIsMoveModeEnabled = () =>
  useSelector((state) => state.CourseMap.isMoveModeEnabled);
export const useMovabelMapElement= () =>
  useSelector((state) => state.CourseMap.movableMapElement);
export const useCourseScoreCardDetails= () =>
  useSelector((state) => state.CourseMap.course_scorecard_details);
export const useCourseRenderingDetails= () =>
  useSelector((state) => state.CourseMap.details_course_rendering_data);
export const useCourseRenderingLoading= () =>
  useSelector((state) => state.CourseMap.details_course_rendering_status);
export const useCourseRenderingCourseInt= () =>
  useSelector((state) => state.CourseMap.details_course_rendering_courseInt);
export const useCourseRenderingOptions = () =>
  useSelector((state) => state.CourseMap.course_rendering_options_data);
export const useCourseRenderingOptionsStatus = () =>
  useSelector((state) => state.CourseMap.course_rendering_options_status);
export const useCourseMappingNoteList= () =>
  useSelector((state) => state.CourseMap.course_mapping_note_list);
  export const useCourseScoreCardLoading= () =>
  useSelector((state) => state.CourseMap.course_scorecard_details_status);
export const useCourseMarkerTreeDesc= () =>
    useSelector((state) => state.CourseMap.markerHazardTreeDesc);
export const useCourseMarkerTreeSize= () =>
  useSelector((state) => state.CourseMap.markerHazardTreeSize);
export const useCourseMarkerTreeType= () =>
  useSelector((state) => state.CourseMap.markerHazardTreeType);
export const useCourseCliffDescType= () =>
  useSelector((state) => state.CourseMap.cliffPropertiesDesc);
export const useCourseCliffType= () =>
  useSelector((state) => state.CourseMap.cliffPropertiesType);
export const useCourseNativeAreaDesc= () =>
  useSelector((state) => state.CourseMap.nativeAreaPolygonDesc);
export const useCourseNativeAreaType= () =>
  useSelector((state) => state.CourseMap.nativeAreaPolygonType);
export const useCourseNativeAreaSize= () =>
  useSelector((state) => state.CourseMap.nativeAreaPolygonSize);
export const useCourseFixtureMarkerType= () =>
  useSelector((state) => state.CourseMap.fixtureMarkerType);
export const useCourseFixtureMarkerSize= () =>
  useSelector((state) => state.CourseMap.fixtureMarkerSize);
export const useCourseForestPolygonType= () =>
  useSelector((state) => state.CourseMap.forestPolygonType);
export const useCourseHoleData= () =>
  useSelector((state) => state.CourseMap.holeWiseData);
export const useMarkerPointToBlink= () =>
  useSelector((state) => state.CourseMap.selectedEditedMarkerPoint);
export const useMarkerLocationpoint= () =>
  useSelector((state) => state.CourseMap.setMarkerPointLatlon);
export const useCourseHoleNumber= () =>
  useSelector((state) => state.CourseMap.selectedHoleNo);
export const useCourseCreekSize = () =>
  useSelector((state) => state.CourseMap.creekSizeValue);
export const useCourseLavaType = () =>
  useSelector((state) => state.CourseMap.lavaTypeValue);
export const useCourseResidenceDesc = () =>
  useSelector((state) => state.CourseMap.residenceDescValue);
export const useCourseResidenceType = () =>
  useSelector((state) => state.CourseMap.residenceTypeValue);
export const useCourseResidenceSize = () =>
  useSelector((state) => state.CourseMap.residenceSizeValue);
export const useCourseBuildingDesc = () =>
  useSelector((state) => state.CourseMap.buildingDescValue);
export const useCourseBuildingType = () =>
  useSelector((state) => state.CourseMap.buildingTypeValue);
export const useCourseBuildingSize = () =>
  useSelector((state) => state.CourseMap.buildingSizeValue);
export const useCourseParkingLotDesc = () =>
  useSelector((state) => state.CourseMap.parkingLotDescValue);
export const useCourseStreetDesc = () =>
  useSelector((state) => state.CourseMap.streetDescValue);
export const useCourseStreetSize = () =>
  useSelector((state) => state.CourseMap.streetSizeValue);
export const useCourseFenceDesc = () =>
  useSelector((state) => state.CourseMap.fenceDescValue);
export const useCourseFenceSize = () =>
  useSelector((state) => state.CourseMap.fenceSizeValue);
export const useCourseWaterDesc = () =>
  useSelector((state) => state.CourseMap.waterDescValue);
export const useCourseWaterType = () =>
  useSelector((state) => state.CourseMap.waterTypeValue);
export const useCourseWaterSize = () =>
  useSelector((state) => state.CourseMap.waterSizeValue);
export const useCoursePathDesc = () =>
  useSelector((state) => state.CourseMap.pathDescValue);
export const useCourseClubhouseDesc = () =>
  useSelector((state) => state.CourseMap.clubhouseDescValue);
export const useCourseClubhouseType = () =>
  useSelector((state) => state.CourseMap.clubhouseTypeValue);
export const useCourseClubhouseSize = () =>
  useSelector((state) => state.CourseMap.clubhouseSizeValue);